import type { BuildFields } from 'ra-data-hasura';
import gql from 'graphql-tag';
import { extractFieldsFromQuery } from '../Common';

// Define the additional fields that we want.
const EXTEND = gql`
  {
    stage {
      name
      hasReject
      isStarting
    }
    production_unit {
      name
      quantity
      lot {
        name
        endDate
        project {
          name
          unitProd
          unitMeasure
          hasExternalProductionFile
        }
      }
    },
    stage_info {
      team {
        id
        name
        manager {
          fullname
          email
        }
      }
    },
    team_next {
      id
      name
    },
    team_reject {
      id
      name
    },
    team {
      id
      name
      manager {
        fullname
        email
      }
    }
  }
`;

const taskDAO = (defaultFields: BuildFields) => {
  const relatedEntities = extractFieldsFromQuery(EXTEND);
  defaultFields.push(...relatedEntities);
  return defaultFields;
};

export default taskDAO;